"use strict";
exports.__esModule = true;
exports.DiscountType = void 0;
/**
 * Discount types supported by integrations, whether general (like `student`) or vendor-specific.
 * This should include any discount type that is independent of age selection
 * and that we allow users to apply for at the time of search.
 */
var DiscountType;
(function (DiscountType) {
    DiscountType["Student"] = "student";
    DiscountType["Military"] = "military";
    DiscountType["Teacher"] = "teacher";
    /** INAPAM (Mexico senior discount card) */
    DiscountType["INAPAM"] = "inapam";
})(DiscountType = exports.DiscountType || (exports.DiscountType = {}));
